const controller = "product-usage-events";

export default {
  controller,
};
